export const colors = {
  primary: "#017E7E",
  secondary: "#0B5556",
  tertiary: "#44E0D9",
  textDark: "#192030",
  textMedium: "#3D5360",
  background: "#F2F4F5",
  strokeGray: "#CACBCD",
  strokeGrayTable: "#ACB8BD",
  green: "#15cb3c",
  yellow: "#FFC400",
  red: "#F84241",
  purple: "#CEB7FF",
  white: "#FFFFFF",
  greenBackground: "#D9F7DA",
  yellowBackground: "#FFF9CF",
  redBackground: "#FFEEEE",
  gradient: "linear-gradient(90deg, #4B75C3, #00A6A4, #2BE4DB )",
  blue: "#0D80F2",
  blueBackground: "#DEECF8",
  grey: "#F2F6F8",
  blackGray:'#182930',
  feedbackTitleColor:'#607A8C',
  feedbackBackground: '#E6FAFC',
  hoverBlue: '#0041a8',
};

export const theme = {
  colors: colors,
  typography: {
    heading1_semiBold: {
      fontFamily: "Volte",
      fontSize: "1.5rem",
      lineHeight: "0rem",
      fontWeight: "600",
      letterSpacing: "0.005em",
    },
    heading2_semiBold: {
      fontFamily: "Volte",
      fontSize: "2.5rem",
      lineHeight: "3rem",
      fontWeight: "600",
      letterSpacing: "0.005em",
    },
    heading3_medium: {
      fontFamily: "Volte",
      fontSize: "30px",
      fontWeight: "500",
      lineHeight: "36px",
      colors: colors.textMedium,
    },
    heading4_semiBold: {
      fontFamily: "Volte",
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "24px",
      colors: colors.textMedium,
    },
    heading4_medium: {
      fontFamily: "Volte",
      fontSize: "20px",
      fontWeight: "500",
      lineHeight: "24px",
      colors: colors.textMedium,
    },
    body: {
      fontFamily: "Volte",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "400",
    },
    bodyMedium: {
      fontFamily: "Volte",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      colors: colors.textDark,
    },
    body_semiBold: {
      fontFamily: "Volte",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "17.6px",
    },
    subbody_medium: {
      fontFamily: "Volte",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "17.6px",
      colors: colors.textMedium,
    },
    button: {
      fontFamily: "Volte",
      color: "#FFFFFF",
      fontWeight: "600",
    },
  },
  radius: {
    ss: "2px",
    xs: "8px",
    sm: "12px",
    md: "16px",
    full: "32px",
  },
  spacing: {
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    xxl: "20px",
    xxxl: "24px",
    "4xl": "32px",
    "5xl": "40px",
    "8xl": "80px",
  },
  buttonSizes: {
    sm: {
      height: "32px",
      fontSize: "16px",
      iconSize: "12px",
    },
    md: {
      height: "40px",
      fontSize: "20px",
      iconSize: "24px",
    },
    lg: {
      height: "48px",
      fontSize: "24px",
      iconSize: "24px",
    },
  },
  shadows: {
    medium: "0px 4px 30px rgba(0, 0, 0, 0.15)",
    shallow: "0px 4px 24px rgba(0, 0, 0, 0.10)",
  },
};

export const themeTwo = {
  // other overrides for this brand
  ...theme,
  colors: {
    ...theme.colors,
    primary: "#232D48",
    secondary: "#232D48",
    feedbackTitleColor:'#2D4675',
    feedbackBackground: '#F1F7FD',
    blue: "#2D4675",
    blueBackground: "#D2E6FF",
    hoverBlue: '#2D4675',
  },
};

export type Theme = typeof theme;
